import ReactSelect from 'react-select'
import selectStyles from './select-styles'

export default function Select({
  options,
  active,
  callback,
  style = 'default',
}) {
  /**
   * Parse options to a format that ReactSelect understands.
   */
  const selectOptions = options.map((option) => ({
    label: option.name,
    value: option.slug,
  }))

  /**
   * Handle value change.
   * Store name of selection to store.
   */
  const handleChange = (value) => {
    // Get name of value slug.
    const item = options.filter((option) => option.slug === value)
    if (item.length > 0) {
      callback(item[0].name)
    }
  }

  const getActive = () => {
    if (active !== '') {
      const item = selectOptions.filter((option) => option.label === active)

      if (item.length > 0) {
        return item[0]
      }
    }

    return selectOptions[0]
  }

  return (
    <ReactSelect
      options={selectOptions}
      onChange={({ value }) => handleChange(value)}
      value={getActive()}
      styles={style === 'default' ? selectStyles : style}
      classNamePrefix={'select-tertiary'}
      isSearchable={false}
    />
  )
}
